<template lang="pug">
  div(v-cloak v-if="hasTrial")
    v-layout(row wrap)
      v-flex(xs12 v-if="writeBackToken")
        v-alert(
          :value="true"
          type="info"
          color="accent"
          outline
        )
          span 編集中
          v-chip.my-0(small disabled outline color="accent")
            span No. {{writeBackIndex + 1}}
          v-chip.my-0(small disabled outline color="accent")
            v-avatar
              v-icon fa-cube
            span {{writeBackToken}}
      v-flex(xs12)
        v-btn(color="primary" @click="pushBox" :disabled="nextBoxesNum > 10")
          v-icon add
          span この試算結果を見積一覧に追加する

        v-btn(flat color="warning" @click="abandonTrial")
          v-icon close
          span この試算結果を破棄する

        v-alert(type="warning" value="true" v-show="nextBoxesNum > 10")
          span 一度に追加できる見積は、別枠オプション、値引(0円以外の数値)を含み10件までです。この試算を追加後の総明細数 : {{nextBoxesNum}}
    order-box
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'underscore'
import OrderBox from './Box'

export default {
  components: {
    OrderBox
  },
  data () {
    return {}
  },
  created () {
    this.clearTrial()
  },
  computed: {
    ...mapGetters('app/order', ['hasTrial', 'trial', 'boxes', 'summary', 'writeBackToken', 'writeBackIndex']),
    nextBoxesNum () {
      let len = 1 + this.trial.input.appendices.length
      _.each(this.boxes, function (box) {
        len += 1 + box.input.appendices.length
      })
      len += parseInt(this.summary.discount, 10) !== 0 ? 1 : 0
      return len
    }
  },
  methods: {
    ...mapActions('app/order', ['activateTab', 'clearTrial', 'pushTrialToList']),
    pushBox () {
      let self = this
      self.pushTrialToList()
      self.clearTrial()
      this.$toastr.success('追加しました。')
      this.activateTab('list')
    },
    abandonTrial () {
      this.clearTrial()
      this.activateTab('input')
    }
  }
}
</script>

<style scoped lang="stylus">
.subheader {
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Components/Trial.vue